import { render, staticRenderFns } from "./menuItems.vue?vue&type=template&id=63c4c975"
import script from "./menuItems.vue?vue&type=script&lang=js"
export * from "./menuItems.vue?vue&type=script&lang=js"
import style0 from "./menuItems.vue?vue&type=style&index=0&id=63c4c975&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports